(function (tests) {
  'use strict';

  function amplitudeABTestIdentify() {
    if (tests) {
      const identity = new amplitude.Identify();

      Object.keys(tests).forEach((testName) => {
        const value = tests[testName]
        if (value !== 'none') {
          identity.set(testName, value);
        }
      });

      amplitude.getInstance().identify(identity);
    }
  }

  if (typeof amplitude !== 'undefined') {
    amplitudeABTestIdentify();
  }
})(window.amplitude_ab_tests);
